import { cn } from '@/lib/utils';

/**
 * Dessin commun des sélecteurs à onglets coach (Templates « Séances / Semaines »,
 * fiche élève « Analyse / RM potentiel », filtres du classement) : rail blanc
 * à 5 % (visible sur le fond sombre, sans contour), 4 px d'air autour des onglets, pastille cuivre
 * qui glisse sous l'onglet actif.
 */
export const SEGMENTED_TRACK =
  'inline-flex items-center gap-1 rounded-full bg-white/[0.05] p-1';

export const SEGMENTED_INDICATOR =
  'absolute rounded-full bg-[#d4845a] shadow-[inset_0_1px_0_rgba(255,255,255,0.18)]';

const SIZES = {
  sm: 'px-4 py-1.5 text-[13px]',
  md: 'px-6 py-2.5 text-sm',
};

export const segmentClass = (active, size = 'md') =>
  cn(
    'relative shrink-0 whitespace-nowrap rounded-full font-medium outline-none transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-[#d4845a]',
    SIZES[size],
    active ? 'text-white' : 'text-white/50 hover:text-white/80',
  );
